<template>
  <div class="page-wrap" id="f-book-now">

    <!-- Full-screen saving overlay -->
    <transition name="fade">
      <div class="processing-overlay" v-if="saveDataLoader">
        <div class="processing-card">
          <i class="fa fa-circle-o-notch fa-spin"></i>
          <div class="processing-title" v-html="loadingMessage"></div>
        </div>
      </div>
    </transition>

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-plus-circle"></i></div>
          <div>
            <div class="panel-title">Add New Service</div>
            <div class="panel-sub">Appointment #{{ $route.params.app_id }}</div>
          </div>
        </div>
        <button class="btn-back" @click="goback()">
          <i class="fa fa-arrow-left"></i> Go Back
        </button>
      </div>

      <!-- Step bar -->
      <div class="step-bar">
        <div class="step" :class="{ active: current_page >= 1, done: current_page > 1 }">
          <div class="step-dot"><i class="fa" :class="current_page > 1 ? 'fa-check' : 'fa-th-large'"></i></div>
          <span>Select Service</span>
        </div>
        <div class="step-line" :class="{ done: current_page > 1 }"></div>
        <div class="step" :class="{ active: current_page >= 2 }">
          <div class="step-dot"><i class="fa fa-credit-card"></i></div>
          <span>Payment</span>
        </div>
      </div>

      <!-- Error alert -->
      <div class="error-strip" v-if="errorMsg && errorMsg.length">
        <i class="fa fa-exclamation-circle"></i>
        <span>{{ errorMsg }}</span>
      </div>

      <!-- ── Page 1: Service selection ── -->
      <div class="svc-wrap" v-if="current_page == 1">

        <!-- Search bar -->
        <div class="svc-toolbar">
          <div class="svc-search">
            <i class="fa fa-search"></i>
            <input
              v-model="searchInput"
              type="text"
              placeholder="Search services…"
              class="svc-search__input"
            />
            <button v-if="searchInput" class="svc-search__clear" @click="searchInput = ''">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>

        <!-- Loading -->
        <div class="svc-loading" v-if="dataLoading">
          <div class="svc-loading__spinner"></div>
          <span>Loading services…</span>
        </div>

        <!-- Service grid -->
        <div class="svc-grid" v-if="!dataLoading">
          <div
            class="svc-card-wrap"
            v-for="(service, index) in filteredServices"
            :key="index"
            :class="{ 'svc-card-wrap--selected': selected_index == index }"
          >
            <v-service-card
              :front_status="false"
              :url="url"
              :service="service"
              :index="index"
              @setserviceindex="setServiceindex"
            ></v-service-card>
          </div>

          <!-- Empty state -->
          <div class="svc-empty" v-if="filteredServices.length === 0">
            <i class="fa fa-search"></i>
            <p>No services found</p>
          </div>
        </div>

      </div>

      <!-- ── Page 2: Payment ── -->
      <template v-if="current_page == 2">
        <div class="section-grid">
          <div class="section-label">
            <i class="fa fa-receipt"></i> Service Summary
          </div>
          <div class="section-label">
            <i class="fa fa-credit-card"></i> Payment
          </div>
        </div>
        <div class="payment-wrap">
          <f-payment :front_status="false"></f-payment>
        </div>
      </template>

    </div>

    <!-- Floating save bar -->
    <div class="save-bar">
      <div class="save-bar-total" v-if="current_page == 2 && getfClientRate && (getServiceTypeCode != 'fdle' || getServiceOriCode.success == true)">
        <span class="sbt-label">Total</span>
        <span class="sbt-amount">${{ getTotalServiceAmount }}</span>
      </div>
      <div class="save-bar-total" v-else-if="current_page == 1">
        <span class="sbt-step">Step 1 of 2 — select a service to continue</span>
      </div>
      <div class="save-bar-actions">
        <button class="btn-cancel" @click="goback()">
          <i class="fa fa-arrow-left"></i> Go Back
        </button>
        <button class="btn-submit" v-if="current_page == 2" @click="submitService()">
          <i class="fa fa-check"></i> Submit
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import vServiceCard from "@/components/frontend/groupservicecard";
import vNoRecord from "@/components/frontend/norecord";
import fPayment from "@/pages/frontend/booknow/payment.vue";
import {
  SET_BREADCRUMB,
  SET_F_CLIENT_ENABLE_ON_SITE_PAYMENT,
  UPDATE_ABBREVIATION_CODE,
  SET_PAYMENT_CARD_PROPERTY,
  SET_PAYMENT_CARD_TYPE,
  SET_PAYMENT_CARD_NUMBER,
  SET_PAYMENT_CARD_HOLDER_NAME,
  SET_PAYMENT_CARD_ADDRESS,
  SET_PAYMENT_CARD_CITY,
  SET_PAYMENT_CARD_CVV_NUMBER,
  SET_PAYMENT_CARD_EXPIRY_DATE,
  CARD_COUNTRY,
  CARD_STATE,
  SET_F_CLIENT_RATE,
  UPDATE_PAYMENT_TYPE,
  SET_PAYMENT_CARD_NUMBER_PHONE,
  SET_PAYMENT_CARD_NUMBER_POSTAL,
  SET_NEW_APP_NO,
  SET_RATE_TOTAL_AMOUNT,
  SET_ADD_RATE_QTY,
  UPDATE_SERVICE_ORI_CODE,
  SET_CHECK_F_SERVICE_ORI_CODE,
  UPDATE_ORI,
  SET_ADDITIONAL_CARD_TOTAL_AMOUNT,
  SET_TOTAL_SERVICE_AMOUNT,
  SET_ENABLE_ORI_RATE,
  SET_SERVICE_TYPE_CODE
} from "@/core/services/store/mutations.type";

import {
  LOCATION_SERVICE,
  FETCH_F_CLIENT_RATE,
  NEW_APPOINTMENT,
  STORE_APPOINTMENT_FROM_APPLICANT,
  MAKE_INVOICE_AFTER_ONLINE_PAYEMENT,
  FETCH_COUNTRIES,
  FETCH_STATES,
  CHECK_F_SERVICE_ORI_CODE
} from "@/core/services/store/actions.type";
import { mapGetters } from "vuex";

export default {
  components: {
    vServiceCard,
    vNoRecord,
    fPayment
  },
  mounted() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.$store.commit(
      SET_F_CLIENT_ENABLE_ON_SITE_PAYMENT,
      this.$route.params.onsite
    );
    this.$store.commit(SET_RATE_TOTAL_AMOUNT, 0);
    this.$store.commit(SET_ADD_RATE_QTY, 0);
    this.$store.commit(UPDATE_ABBREVIATION_CODE, "");
    this.$store.commit(SET_PAYMENT_CARD_PROPERTY, "");
    this.$store.commit(SET_PAYMENT_CARD_TYPE, "");
    this.$store.commit(SET_PAYMENT_CARD_NUMBER, "");
    this.$store.commit(SET_PAYMENT_CARD_HOLDER_NAME, "");
    this.$store.commit(SET_PAYMENT_CARD_ADDRESS, "");
    this.$store.commit(SET_PAYMENT_CARD_CITY, "");
    this.$store.commit(SET_PAYMENT_CARD_CVV_NUMBER, "");
    this.$store.commit(SET_PAYMENT_CARD_EXPIRY_DATE, "");
    this.$store.commit(CARD_COUNTRY, "US");
    this.$store.commit(CARD_STATE, "");
    this.$store.commit(SET_PAYMENT_CARD_NUMBER_PHONE, "");
    this.$store.commit(SET_PAYMENT_CARD_NUMBER_POSTAL, "");
    this.$store.commit(SET_ENABLE_ORI_RATE, "");
    this.$store.commit(SET_SERVICE_TYPE_CODE, "");
    this.$store.commit(SET_CHECK_F_SERVICE_ORI_CODE, {
      data: "",
      success: "none"
    });
    this.fetchServices();
    this.$store.dispatch(FETCH_COUNTRIES);
    this.$store.dispatch(FETCH_STATES);
  },
  data() {
    return {
      service_ori: "",
      service_ori_code_error: false,
      errorMsg: [],
      current_page: 1,
      dataLoading: false,
      services: [],
      url: "",
      searchInput: "",
      selected_index: -1,
      breadCrumbs: [
        { id: 1, title: "Dashboard",        route: "client.dashboard" },
        { id: 2, title: "Appointment List", route: "" },
        { id: 2, title: "New Service",      route: "" }
      ],
      saveDataLoader: false,
      loadingMessage: "",
      rateData: []
    };
  },
  computed: {
    filteredServices() {
      let tempServices = this.services;
      if (this.searchInput != "" && this.searchInput) {
        tempServices = tempServices.filter(item => {
          return item.name
            .toUpperCase()
            .includes(this.searchInput.toUpperCase());
        });
      }
      return tempServices;
    },
    ...mapGetters([
      "getServiceId",
      "getNewAppNo",
      "getTotalRateAmount",
      "getfClientRate",
      "getAbbreviationCode",
      "updateAbbreviationCode",
      "getAddQty",
      "getPaymentCardNumber",
      "getPaymentCardHolderName",
      "getPaymentCardExpiry",
      "getPaymentCardCvvNumber",
      "getPaymentCardType",
      "getSelectedCountryPhoneCode",
      "getPaymentCardHolderAddress",
      "getPaymentCardHolderCountry",
      "getPaymentCardHolderState",
      "getPaymentCardHolderCity",
      "getApplicantDobMonth",
      "getApplicantDobDay",
      "getApplicantDobYear",
      "getPaymentCardPhonecode",
      "getPaymentCardPhone",
      "getPaymentCardPostalZip",
      "getPaymentType",
      "getServiceProviderData",
      "getIsHeartsPayment",
      "getTotalServiceAmount",
      "getServiceTypeCode",
      "getServiceOriCode",
      "getServiceOri",
      "updateServiceOriCode",
      "getTotalAdditionalAmount"
    ])
  },
  filters: {
    toFixedTwoDigit(amount, data) {
      var rate = parseFloat(data.rate) * parseInt(data.service.default_qty);
      var tp = parseFloat(data.tax_percentage);
      if (rate > 0) {
        return (parseFloat(amount) + (rate + (rate * tp) / 100)).toFixed(2);
      } else {
        return 0;
      }
    }
  },
  methods: {
    reset() {
      this.$store.commit(UPDATE_ABBREVIATION_CODE, "");
      this.$store.commit(SET_PAYMENT_CARD_PROPERTY, "");
      this.$store.commit(SET_PAYMENT_CARD_TYPE, "");
      this.$store.commit(SET_PAYMENT_CARD_NUMBER, "");
      this.$store.commit(SET_PAYMENT_CARD_HOLDER_NAME, "");
      this.$store.commit(SET_PAYMENT_CARD_ADDRESS, "");
      this.$store.commit(SET_PAYMENT_CARD_CITY, "");
      this.$store.commit(SET_PAYMENT_CARD_CVV_NUMBER, "");
      this.$store.commit(SET_PAYMENT_CARD_EXPIRY_DATE, "");
      this.$store.commit(CARD_COUNTRY, "US");
      this.$store.commit(CARD_STATE, "");
      this.$store.commit(SET_NEW_APP_NO, {
        app_id: "",
        appt_id: "",
        time: "",
        appt_token: "",
        date: ""
      });
      this.$store.commit(SET_F_CLIENT_RATE, {
        rate: "0",
        additional_rate: "0",
        service: { default_qty: 0 }
      });
      this.$store.commit(UPDATE_PAYMENT_TYPE, "C");
      this.$store.commit(SET_PAYMENT_CARD_NUMBER_PHONE, "");
      this.$store.commit(SET_PAYMENT_CARD_NUMBER_POSTAL, "");
      this.$store.commit(UPDATE_ORI, "");
      this.$store.commit(UPDATE_SERVICE_ORI_CODE, "");
      this.$store.commit(SET_CHECK_F_SERVICE_ORI_CODE, {
        data: "",
        success: "none"
      });
    },
    submit() {
      var mytoken = document.getElementById("mytoken");
      mytoken = mytoken.innerHTML;
      if (this.updateAbbreviationCode != "") {
        if (!this.getAbbreviationCode.success) {
          this.$toastr.e(this.getAbbreviationCode.msg);
        } else {
          if (this.getPaymentType == "C") {
            this.loadingMessage =
              "please wait <br> While we process your payment...";
            if (mytoken == "" || mytoken == null) {
              this.$toastr.e(
                "The card number entered is not compliant, please check and re-enter."
              );
            } else {
              if (this.getIsHeartsPayment) {
                var expiremonth = document.getElementById("expiremonth").innerHTML;
                var expireyear  = document.getElementById("expireyear").innerHTML;
                if (mytoken == "" || mytoken == null || expiremonth == "" || expiremonth == null || expireyear == "" || expireyear == null) {
                  this.$toastr.e("Card info is required");
                } else {
                  this.SubmitForm();
                }
              } else {
                if (mytoken == "" || mytoken == null || this.getPaymentCardHolderName == "" || this.getPaymentCardExpiry == "" || this.getPaymentCardCvvNumber == "") {
                  this.$toastr.e("Card info is required");
                } else {
                  this.SubmitForm();
                }
              }
            }
          } else {
            this.loadingMessage = "please wait <br> Your appointment is being scheduled...";
            this.SubmitForm();
          }
        }
      } else {
        if (this.getPaymentType == "C") {
          this.loadingMessage = "please wait <br> While we process your payment...";
          if (mytoken == "" || mytoken == null) {
            this.$toastr.e("The card number entered is not compliant, please check and re-enter.");
          } else {
            if (this.getIsHeartsPayment) {
              var expiremonth2 = document.getElementById("expiremonth").innerHTML;
              var expireyear2  = document.getElementById("expireyear").innerHTML;
              if (mytoken == "" || mytoken == null || expiremonth2 == "" || expiremonth2 == null || expireyear2 == "" || expireyear2 == null) {
                this.$toastr.e("Card info is required");
              } else {
                this.SubmitForm();
              }
            } else {
              if (mytoken == "" || mytoken == null || this.getPaymentCardHolderName == "" || this.getPaymentCardExpiry == "" || this.getPaymentCardCvvNumber == "") {
                this.$toastr.e("Card info is required");
              } else {
                this.SubmitForm();
              }
            }
          }
        } else {
          this.loadingMessage = "please wait <br> Your appointment is being scheduled...";
          this.SubmitForm();
        }
      }
    },
    timeFormat(value, date) {
      var fullDate = date + " " + value;
      return this.$moment(fullDate).format("hh:mm a");
    },
    SubmitForm() {
      this.errorMsg = "";
      let updateAbbreviationCode = "";
      if (this.getAbbreviationCode.data.length == 0) {
        updateAbbreviationCode = "";
      } else {
        updateAbbreviationCode = this.updateAbbreviationCode;
      }
      this.saveDataLoader = true;
      var mytoken = document.getElementById("mytoken");
      var formData = {
        type: this.getPaymentType,
        appointment_id: this.getNewAppNo.app_id,
        applicant_id: this.getNewAppNo.appt_id,
        abbreviation_code: updateAbbreviationCode,
        sms_status: false,
        appt_token: this.getNewAppNo.appt_token,
        service_ori: this.getServiceOri,
        time: { start: this.timeFormat(this.getNewAppNo.time, this.getNewAppNo.date) }
      };
      var invoice_details = [];
      var data_1 = {
        qty: this.getfClientRate.service.default_qty,
        is_additional: 0,
        title: "Service Name: " + this.getfClientRate.title
      };
      invoice_details.push(data_1);
      if (this.getAddQty > 0) {
        var note = this.getfClientRate.service.additional_field_note
          ? this.getfClientRate.service.additional_field_note
          : "Additional: Yes";
        invoice_details.push({
          qty: this.getAddQty,
          is_additional: 1,
          title: `${note} (${this.getAddQty})`
        });
      }
      let token = mytoken.innerHTML;
      if (this.getPaymentType == "C") {
        if (this.getIsHeartsPayment) {
          var expiremonth = document.getElementById("expiremonth");
          var expireyear  = document.getElementById("expireyear");
          var token_type  = document.getElementById("token_type");
          var last_four   = document.getElementById("last_four");
          var card_type   = document.getElementById("card_type");
          formData.payment_details = {
            hearts_token: token,
            expire_month: expiremonth.innerHTML,
            expire_year:  expireyear.innerHTML,
            card_cvv_no:  this.getPaymentCardCvvNumber,
            postal:       this.getPaymentCardPostalZip,
            token_type:   token_type.innerHTML,
            last_four:    last_four.innerHTML,
            card_type:    card_type.innerHTML,
            card_address: this.getPaymentCardHolderAddress
          };
        } else {
          formData.payment_details = {
            card_number:      token,
            card_holder_name: this.getPaymentCardHolderName,
            card_expiry:      this.getPaymentCardExpiry,
            card_cvv_no:      this.getPaymentCardCvvNumber,
            card_type:        this.getPaymentCardType,
            card_address:     this.getPaymentCardHolderAddress,
            card_city:        this.getPaymentCardHolderCity,
            card_country:     this.getPaymentCardHolderCountry,
            card_state:       this.getPaymentCardHolderState,
            phone:            this.getPaymentCardPhonecode.dial_code + this.getPaymentCardPhone,
            postal:           this.getPaymentCardPostalZip
          };
        }
      }
      formData.invoice_details = invoice_details;

      this.$store
        .dispatch(STORE_APPOINTMENT_FROM_APPLICANT, {
          url: this.getPaymentType == "C"
            ? "appointment/applicant/payment"
            : "submit/appointment/applicant/",
          data: formData
        })
        .then(res => {
          if (this.getPaymentType != "C") {
            this.saveDataLoader = false;
            this.$toastr.s(res.msg);
            this.$store
              .dispatch(MAKE_INVOICE_AFTER_ONLINE_PAYEMENT, {
                appointment_id: this.getNewAppNo.app_id,
                invoice_details: invoice_details,
                card_type:   this.getPaymentCardType,
                card_number: this.getPaymentCardNumber.replace(" ", "").slice(-4),
                appt_token:  this.getNewAppNo.appt_token,
                card_token:  "",
                invoice_id:  res.invoice_id,
                service_ori: this.getServiceOri
              })
              .then(() => { this.saveDataLoader = false; })
              .catch(errs => { this.errorMsg = errs.msg; this.saveDataLoader = false; });
            this.reset();
            this.$router.go(-1);
          } else {
            this.$store
              .dispatch(MAKE_INVOICE_AFTER_ONLINE_PAYEMENT, {
                appointment_id: this.getNewAppNo.app_id,
                invoice_details: invoice_details,
                card_type:   this.getPaymentCardType,
                card_number: this.getPaymentCardNumber.replace(" ", "").slice(-4),
                appt_token:  this.getNewAppNo.appt_token,
                card_token:  "",
                invoice_id:  res.invoice_id,
                service_ori: this.getServiceOri
              })
              .then(() => { this.saveDataLoader = false; })
              .catch(errs => { this.errorMsg = errs.msg; this.saveDataLoader = false; });
            this.$toastr.s(res.msg);
            this.reset();
            this.$router.go(-1);
          }
        })
        .catch(errs => {
          if (errs.msg != "") {
            this.errorMsg = errs.msg;
            this.$toastr.e(errs.msg);
          }
          this.saveDataLoader = false;
        });
    },
    goback() {
      this.reset();
      if (this.current_page == 1) {
        this.$router.go(-1);
      } else {
        this.$store.commit(SET_F_CLIENT_RATE, {
          rate: "0",
          additional_rate: "0",
          service: { default_qty: 0 }
        });
        this.$store.commit(SET_RATE_TOTAL_AMOUNT, 0);
        this.$store.commit(SET_ADD_RATE_QTY, 0);
        this.current_page = 1;
        let breadCrumbs_copy = [...this.breadCrumbs];
        breadCrumbs_copy.pop();
        this.breadCrumbs = breadCrumbs_copy;
        this.$store.commit(SET_BREADCRUMB, breadCrumbs_copy);
      }
    },
    updateOri(e) {
      this.$store.commit(UPDATE_SERVICE_ORI_CODE, e.target.value);
      this.$store.commit(SET_CHECK_F_SERVICE_ORI_CODE, { data: "", success: "none" });
    },
    checkServiceOri() {
      if (this.updateServiceOriCode != "") {
        this.service_ori_code_error = true;
        var service_id = this.getServiceId;
        this.$store
          .dispatch(CHECK_F_SERVICE_ORI_CODE, {
            service_code: this.getServiceTypeCode,
            code: this.updateServiceOriCode,
            client: this.$route.params.id,
            service: service_id
          })
          .then(data => {
            if (data.success) {
              this.$store.commit(UPDATE_SERVICE_ORI_CODE, data.data.ori_number);
              this.$store.commit(UPDATE_ORI, data.data.service_ori_id);
              this.rateData = data.data;
              this.qty = data.data.service.is_drug_testing ? this.getQty : data.data.service.default_qty;
              var rate = parseFloat(data.data.rate);
              var tax_percentage_amount = parseFloat(((parseFloat(data.data.tax_percentage) / 100) * rate * this.qty).toFixed(2));
              var tax_additional_amount = (parseFloat(data.data.tax_percentage) / 100) * data.data.additional_rate * this.getAddQty;
              this.$store.commit(SET_ADDITIONAL_CARD_TOTAL_AMOUNT, parseFloat(data.data.additional_rate * this.getAddQty + tax_additional_amount).toFixed(2));
              this.$store.commit(SET_RATE_TOTAL_AMOUNT, parseFloat(rate * this.qty + tax_percentage_amount).toFixed(2));
              this.$store.commit(SET_TOTAL_SERVICE_AMOUNT, parseFloat(rate * this.qty + tax_percentage_amount).toFixed(2));
              this.service_ori = "";
            } else {
              this.service_ori_code_error = true;
            }
          });
      } else {
        this.service_ori_code_error = true;
      }
    },
    removeServiceOri() {
      this.$store.commit(UPDATE_ORI, "");
      this.service_ori_code_error = false;
      this.$store.commit(UPDATE_SERVICE_ORI_CODE, "");
      this.$store.commit(SET_CHECK_F_SERVICE_ORI_CODE, { data: "", success: "none" });
    },
    setServiceindex(index) {
      this.selected_index = index;
      this.fetchRate();
    },
    fetchRate() {
      this.loadingData = true;
      var service_id = this.getServiceId;
      if (this.updateServiceOriCode != "") {
        this.service_ori = this.updateServiceOriCode;
        this.checkServiceOri();
        this.loadingData = false;
      } else {
        this.$store
          .dispatch(NEW_APPOINTMENT, {
            app_id:     this.$route.params.app_id,
            app_token:  this.$route.params.token,
            service_id: service_id,
            reason:     ""
          })
          .then(res => {
            if (res.code == 200) {
              this.$store
                .dispatch(FETCH_F_CLIENT_RATE, {
                  id:         this.$route.params.id,
                  service_id: service_id
                })
                .then(data => {
                  this.rateData = data;
                  this.$store.commit(SET_F_CLIENT_RATE, data);
                  this.loadingData = true;
                  this.qty = data.service.is_drug_testing ? this.getQty : data.service.default_qty;
                  this.$store.commit(SET_ENABLE_ORI_RATE, data.service.enable_ori_rate);
                  this.$store.commit(SET_SERVICE_TYPE_CODE, data.service.service_type_code);
                  var rate = data.rate;
                  var tax_percentage_amount = (parseFloat(data.tax_percentage) / 100) * rate * this.qty;
                  var tax_additional_amount = (parseFloat(data.tax_percentage) / 100) * data.additional_rate * this.getAddQty;
                  this.$store.commit(SET_ADDITIONAL_CARD_TOTAL_AMOUNT, (data.additional_rate * this.getAddQty + tax_additional_amount).toFixed(2));
                  this.$store.commit(SET_RATE_TOTAL_AMOUNT, (rate * this.qty + tax_percentage_amount).toFixed(2));
                  this.$store.commit(SET_TOTAL_SERVICE_AMOUNT, (rate * this.qty + tax_percentage_amount + parseFloat(this.getTotalAdditionalAmount)).toFixed(2));
                  let breadCrumbs_copy = [...this.breadCrumbs];
                  if (breadCrumbs_copy.length == 3) {
                    breadCrumbs_copy.push({ id: 4, title: "Payment", route: "" });
                  }
                  this.breadCrumbs = breadCrumbs_copy;
                  this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
                  this.current_page = 2;
                  this.loadingData = false;
                })
                .catch(() => { this.loadingData = false; });
            }
          })
          .catch(() => { this.loadingData = false; });
      }
    },
    submitService() {
      if (this.getServiceTypeCode == "fdle") {
        if (this.getServiceOri == "") {
          this.$toastr.e(this.getServiceOriCode.msg ? this.getServiceOriCode.msg : "Please confirm ORI");
        } else {
          this.submit();
        }
      } else {
        this.submit();
      }
    },
    fetchServices() {
      this.dataLoading = true;
      let data = {
        client_id:  this.$route.params.id,
        app_id:     this.$route.params.app_id,
        app_token:  this.$route.params.token
      };
      this.$store
        .dispatch(LOCATION_SERVICE, data)
        .then(data => {
          this.services = data.services;
          this.url = data.url;
          this.dataLoading = false;
        })
        .catch(() => { this.dataLoading = false; });
    }
  }
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$green:  #276749;
$border: #dde2ec;

.page-wrap {
  padding: 8px 0 100px;
  font-family: $font;
}

/* ── Processing overlay ── */
.processing-overlay {
  position: fixed; inset: 0; z-index: 1050;
  background: rgba(13,27,62,0.45);
  backdrop-filter: blur(4px);
  display: flex; align-items: center; justify-content: center;
}
.processing-card {
  background: #fff; border-radius: 14px;
  padding: 32px 40px; text-align: center;
  box-shadow: 0 8px 32px rgba(13,27,62,0.18);
  i { font-size: 28px; color: $blue; margin-bottom: 12px; display: block; }
}
.processing-title { font-size: 13px; color: $dark; font-family: $font; }
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter, .fade-leave-to { opacity: 0; }

/* ── Panel ── */
.panel-card {
  background: #fff; border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13,27,62,0.07); overflow: hidden;
}

/* ── Header ── */
.panel-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 20px; background: #fafbfd;
  border-bottom: 1px solid #eef0f6; gap: 12px; flex-wrap: wrap;
}
.panel-header-left { display: flex; align-items: center; gap: 12px; }
.panel-icon {
  width: 36px; height: 36px; border-radius: 8px;
  background: $blue; color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; flex-shrink: 0;
}
.panel-title { font-size: 14px; font-weight: 700; color: $dark; }
.panel-sub   { font-size: 11px; color: #8a94a6; margin-top: 2px; }

.btn-back {
  display: inline-flex; align-items: center; gap: 6px;
  height: 32px; padding: 0 14px; background: #fff;
  color: #4a5568; border: 1.5px solid $border; border-radius: 8px;
  font-size: 12px; font-weight: 600; font-family: $font;
  cursor: pointer; transition: all 0.15s;
  &:hover { border-color: $blue; color: $blue; }
}

/* ── Step bar ── */
.step-bar {
  display: flex; align-items: center; gap: 0;
  padding: 14px 24px; background: #f8f9fc;
  border-bottom: 1px solid #eef0f6;
}
.step {
  display: flex; align-items: center; gap: 8px;
  .step-dot {
    width: 28px; height: 28px; border-radius: 50%;
    background: #e8edf5; color: #a0aab8;
    display: flex; align-items: center; justify-content: center;
    font-size: 11px; flex-shrink: 0;
    transition: background 0.2s, color 0.2s;
  }
  span { font-size: 12px; font-weight: 600; color: #a0aab8; white-space: nowrap; }
  &.active .step-dot { background: $blue; color: #fff; }
  &.active span     { color: $dark; }
  &.done  .step-dot { background: $green; color: #fff; }
  &.done  span      { color: $green; }
}
.step-line {
  flex: 1; height: 2px; background: #e8edf5; margin: 0 12px;
  transition: background 0.2s;
  &.done { background: $green; }
}

/* ── Error strip ── */
.error-strip {
  display: flex; align-items: flex-start; gap: 10px;
  margin: 16px 20px 0; padding: 12px 16px;
  background: #fef2f2; border: 1px solid #fecaca;
  border-radius: 10px; color: #b91c1c; font-size: 13px; font-weight: 500;
  i { font-size: 14px; margin-top: 1px; flex-shrink: 0; }
}

/* ── Service selection ── */
.svc-wrap { padding: 20px; }

.svc-toolbar { margin-bottom: 16px; }

.svc-search {
  display: flex; align-items: center; gap: 8px;
  background: #f5f8fe; border: 1.5px solid $border;
  border-radius: 9px; padding: 0 12px; max-width: 360px;
  transition: border-color 0.15s;
  &:focus-within { border-color: $blue; }

  i.fa-search { color: #a0aab8; font-size: 13px; flex-shrink: 0; }

  &__input {
    flex: 1; border: none; background: transparent;
    font-size: 13px; color: $dark; font-family: $font;
    height: 36px; outline: none;
    &::placeholder { color: #b0bac8; }
  }
  &__clear {
    background: none; border: none; cursor: pointer;
    color: #a0aab8; padding: 0; font-size: 12px;
    &:hover { color: #e53e3e; }
  }
}

/* Loading */
.svc-loading {
  display: flex; align-items: center; gap: 10px;
  padding: 20px 16px; background: #f5f8fe;
  border: 1px solid #dde8f7; border-radius: 10px;
  color: #5a7ab5; font-size: 13px; font-weight: 500;
  max-width: 320px;

  &__spinner {
    width: 18px; height: 18px; border-radius: 50%;
    border: 2.5px solid #c5d8f5; border-top-color: $blue;
    animation: spin 0.7s linear infinite; flex-shrink: 0;
  }
}
@keyframes spin { to { transform: rotate(360deg); } }

/* Service grid */
.svc-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
}

.svc-card-wrap {
  border-radius: 10px;
  border: 1.5px solid $border;
  overflow: hidden;
  transition: border-color 0.15s, box-shadow 0.15s;
  cursor: pointer;

  &:hover { border-color: $blue; box-shadow: 0 4px 14px rgba(56,154,212,0.1); }

  &--selected {
    border-color: $blue;
    background: #f0f7ff;
    box-shadow: 0 0 0 3px rgba(56,154,212,0.15);
  }
}

.svc-empty {
  grid-column: 1 / -1;
  display: flex; flex-direction: column; align-items: center;
  padding: 48px 20px; color: #a0aab8;
  i { font-size: 32px; margin-bottom: 10px; }
  p { font-size: 13px; }
}

/* ── Section label bar (page 2) ── */
.section-grid {
  display: grid; grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid #eef0f6;
}
.section-label {
  padding: 9px 20px; font-size: 11px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.5px; color: #8a94a6;
  display: flex; align-items: center; gap: 6px;
  background: #f8f9fc; border-right: 1px solid #eef0f6;
  &:last-child { border-right: none; }
  i { color: $blue; font-size: 12px; }
}

/* ── Payment wrap (page 2) ── */
.payment-wrap { padding: 20px; }

/* ── Floating save bar ── */
.save-bar {
  position: fixed; bottom: 2.5rem; width: calc(78vw);
  background: #1a2340; border-radius: 12px; padding: 14px 20px;
  display: flex; align-items: center; justify-content: space-between;
  gap: 16px; box-shadow: 0 8px 32px rgba(13,27,62,0.28);
  z-index: 100; flex-wrap: wrap;
}
.save-bar-total { display: flex; align-items: baseline; gap: 10px; }
.sbt-label  { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; color: #8fa3c8; }
.sbt-amount { font-size: 20px; font-weight: 700; color: #fff; font-family: $font; }
.sbt-step   { font-size: 12px; color: #6a80a8; font-style: italic; }

.save-bar-actions { display: flex; align-items: center; gap: 10px; }

.btn-cancel {
  display: inline-flex; align-items: center; gap: 6px;
  height: 36px; padding: 0 18px; background: transparent;
  color: #a0b3d6; border: 1.5px solid #3a4d6e;
  border-radius: 8px; font-size: 13px; font-weight: 600;
  font-family: $font; cursor: pointer; transition: all 0.15s;
  &:hover { border-color: #e53e3e; color: #e53e3e; }
}
.btn-submit {
  display: inline-flex; align-items: center; gap: 7px;
  height: 36px; padding: 0 22px; background: $green;
  color: #fff; border: none; border-radius: 8px;
  font-size: 13px; font-weight: 600; font-family: $font;
  cursor: pointer; transition: opacity 0.2s;
  &:hover { opacity: 0.9; }
}
</style>

<style lang="scss">
/* ── Service card override (scoped to this page) ── */
#f-book-now {
  #service-container-app {
    padding: 14px 16px !important;
    background: transparent !important;
    border-radius: 0 !important;
    box-shadow: none !important;

    .symbol { display: none !important; }

    .d-flex { gap: 0; }

    a.text-dark-cust {
      font-size: 13px !important;
      font-weight: 600 !important;
      color: #0d1b3e !important;
      margin-bottom: 3px !important;
      display: block;
    }

    span.text-dark-50 {
      font-size: 11.5px !important;
      color: #7a8499 !important;
      line-height: 1.4;
    }
  }
}

/* ── fPayment overrides (page 2, scoped to this page) ── */
$font:  'Segoe UI', sans-serif;
$blue:  #389ad4;
$dark:  #0d1b3e;
$green: #276749;

#f-book-now {
  #f-payement {
    font-family: $font;

    .table-bg-success {
      background: #fff !important;
      border-radius: 10px; overflow: hidden;
      border: 1px solid #e8edf5; font-size: 13px;

      thead tr th {
        background: #f5f8fe; color: #6b7a9b;
        font-size: 11px; font-weight: 700;
        text-transform: uppercase; letter-spacing: 0.4px;
        border-bottom: 1px solid #e8edf5; padding: 9px 12px;
      }
      tbody tr td, tbody tr th {
        padding: 10px 12px; border-bottom: 1px solid #f0f3f9;
        color: $dark; font-size: 13px; vertical-align: middle;
      }
      tbody tr:last-child td, tbody tr:last-child th { border-bottom: none; }
    }

    h4 {
      font-size: 13px; font-weight: 700; color: $dark;
      margin-bottom: 10px; display: flex; align-items: center; gap: 8px;
    }

    h4 .fa-minus, h4 .fa-plus {
      width: 24px; height: 24px; border-radius: 6px;
      background: #f0f4ff; border: 1.5px solid #d0daf7; color: $blue;
      display: inline-flex; align-items: center; justify-content: center;
      font-size: 11px; transition: background 0.15s, border-color 0.15s;
      &:hover { background: $blue; color: #fff; border-color: $blue; }
    }

    h4 span[style*="border"] {
      border: 1.5px solid #dde2ec !important; border-radius: 6px !important;
      padding: 2px 14px !important; font-size: 13px; font-weight: 700;
      color: $dark; min-width: 36px; text-align: center; display: inline-block;
    }

    .abbre-code, .promo-code {
      align-items: center; gap: 12px; margin-bottom: 12px;

      label {
        font-size: 12px; font-weight: 600; color: #6b7a9b;
        line-height: normal !important; width: auto !important; white-space: nowrap;
      }

      .input-group {
        margin-bottom: 0 !important; flex: 1;

        input.form-control {
          border: 1.5px solid #dde2ec; border-radius: 8px 0 0 8px;
          font-size: 13px; height: 36px; color: $dark; padding: 0 12px;
          &:focus { border-color: $blue; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); outline: none; }
        }

        .input-group-append .btn-success {
          background: $green; border-color: $green;
          border-radius: 0 8px 8px 0; height: 36px;
          padding: 0 16px; font-size: 12px; font-weight: 600; font-family: $font;
        }
      }
    }

    strong.text-uppercase { color: $blue; }

    .btn-danger {
      border-radius: 8px; font-size: 12px; font-weight: 600;
      padding: 6px 14px; font-family: $font;
    }

    h5 { font-size: 13px; font-weight: 700; color: $dark; }

    .payment-type {
      list-style: none; padding: 0; margin: 0;

      li {
        background: #fafbfd !important;
        border: 1.5px solid #e8edf5; border-radius: 10px;
        padding: 14px !important; margin-bottom: 10px; cursor: default;
        &:hover { background: #f5f8fe !important; }
        &.active { border-color: $blue !important; background: #f0f7ff !important; }
        .checked-payment { display: none !important; }
        label { margin: 0; span { font-size: 13px; font-weight: 600; color: $dark; } }
      }
    }

    .paymemt-label {
      font-size: 11px !important; font-weight: 700 !important;
      color: #6b7a9b !important; text-transform: uppercase;
      letter-spacing: 0.3px; margin-bottom: 4px !important;
    }

    .form-control {
      border: 1.5px solid #dde2ec; border-radius: 8px;
      font-size: 13px; height: 38px; color: $dark; font-family: $font;
      &:focus { border-color: $blue; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); outline: none; }
    }

    #payment-info { display: block !important; }

    div[style*="background: #eef0f8"],
    div[style*="background: #eef0f8;"] {
      background: #f5f8fe !important; border-radius: 10px;
      padding: 14px !important; border: 1px solid #e8edf5;
    }

    .form-group[style*="inline-flex"] {
      align-items: center; padding: 10px 0 4px;
      label { font-size: 12.5px; color: $dark; margin-top: 0 !important; }
    }

    hr { border-color: #eef0f6; margin: 12px 0; }
  }
}
</style>
